import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ClearIcon(props: IconProps) {
    return <Icon {...props} iconKey={"clear"}/>
}
